import $ from 'jquery';
import React, {Component} from 'react';
import classNames from 'classnames';

import styles from './Select.css';

export default class Select extends Component {
	render() {
		const {
			options,
			children,
			className,
			dispatch,
			...props
		} = this.props;

		const classes = [];
		classes.push(styles.select);
		let reactOptions = [];

		if (Array.isArray(options))
		{
			reactOptions = options.map((pair) => (
				<option
					key={pair.key}
					value={pair.key}
					className={classNames({[styles['option--marked']]: pair.is_marked})}
				>
					{pair.value}
				</option>
			))
		}
		else if ($.isPlainObject(options))
		{
			reactOptions = Object.keys(options).map((value) => (
				<option key={value} value={value}>
					{options[value]}
				</option>
			));
		}

		if (className) {
			classes.push(className);
		}

		return (
			<select className={classes.join(' ')} {...props}>
				{!children && options ? reactOptions : children}
			</select>
		);
	}
}